import * as yup from 'yup';

import { RevenueShareType } from 'src/api';
import { ChangeEmployerBillingFormFields } from 'src/types/billing';

const NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP = /^\d+(\.\d{0,2})?$/;

export const employerBillingRulesFormValidationSchema = yup.object().shape({
  [ChangeEmployerBillingFormFields.revenueShareValue]: yup
    .number()
    .when([ChangeEmployerBillingFormFields.revenueShareType], {
      is: (revenueShareType: RevenueShareType) => revenueShareType === RevenueShareType.Percents,
      then: schema =>
        schema
          .max(100, 'The value should not be more than 100')
          .transform(value => (Number.isNaN(value) ? undefined : value))
          .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
            if (!value) {
              return false;
            }
            return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
          })
          .positive('Should be positive')
          .required('Field is required'),
      otherwise: schema =>
        schema
          .transform(value => (Number.isNaN(value) ? undefined : value))
          .test('maxDigitsAfterDecimal', 'Must have no more than 2 digits after decimal', value => {
            if (!value) {
              return false;
            }
            return NO_MORE_THAN_TWO_DECIMAL_DIGITS_REGEXP.test(value.toString());
          })
          .positive('Should be positive')
          .required('Field is required'),
    }),
});
